import React from 'react'
import { BannerAds } from '../../components/home/BannerAds.jsx'
import { GetStartedSection } from '../../components/home/GetStartedSection.jsx'
import { TopRetailersSection } from '../../components/home/TopRetailersSection.jsx'
import { WhatsNewSection } from '../../components/home/WhatsNewSection.jsx'
import { TopWholesalersSection } from '../../components/home/TopWholesalersSection.jsx'
import { TopSellingSection } from '../../components/home/TopSellingSection.jsx'
import AllProducts from '../../components/home/AllProducts.jsx'
const Home = () => {
  return (
    <div className="">
      <div className="mb-10">
        <BannerAds />
      </div>

      <div className="mt-8 main-container">
        <GetStartedSection />
        <AllProducts />
      </div>

      <div className="mt-8 h-placeholder-md">
        <TopRetailersSection />
      </div>

      <div className="mt-8 h-placeholder-md">
        <WhatsNewSection />
      </div>

      <div className="mt-8 h-placeholder-md">
        <TopWholesalersSection />
      </div>

      <div className="mt-8 h-placeholder-md">
        <TopSellingSection />
      </div>
    </div>
  )
}

export default Home
